const genericFields = {
  labels: {
    name: "Название",
    city: "Город",
  },
  maxLength: {
    name: 65,
    city: 90,
  },
};

const provider = {
  labels: {
    ...genericFields.labels,
    site_url: "Адрес сайта",
    contact_person: "Контактное лицо",
    phone: "Телефон",
  },
  maxLength: {
    ...genericFields.maxLength,
    site_url: 90,
    contact_person: 80,
    phone: 18,
  },
};

const client = {
  labels: {
    ...genericFields.labels,
  },
  maxLength: {
    ...genericFields.maxLength,
  },
};

const requisites = {
  labels: {
    INN: "ИНН",
    email: "E-mail",
    commercial_phone: "Телефон",
    legal_address: "Юридический адрес",
    postal_address: "Почтовый адрес",
    KPP: "КПП",
    OGRN: "ОГРН",
    bank_requisites: "Банковские реквизиты",
    payment_account: "р/с",
    correspondent_account: "к/с",
    BIK: "БИК",
  },
  maxLength: {
    email: 80,
    commercial_phone: 15,
    legal_address: 100,
    postal_address: 100,
    INN: 12,
    KPP: 50,
    OGRN: 50,
    bank_requisites: 50,
    payment_account: 24,
    correspondent_account: 24,
    BIK: 12,
  },
};

export const formsFields = {
  client,
  provider,
  requisites,
};



// WEBPACK FOOTER //
// ./src/business/constants/formsFields.js